// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app__modules_study_study_module_ts":"6eaaf0a180ce034e","src_app__modules_dashboard_dashboard_module_ts":"c4b60dbbfeca890f","node_modules_dompurify_dist_purify_es_mjs":"ff26a30e7111be6f","node_modules_canvg_lib_index_es_js":"183ca2506e9542dc"}[chunkId] + ".js";
};